const STYLES = {
  Disponible: "bg-[#A0553F] text-white",
  Apartado: "bg-[#3E5641] text-white",
  Próximamente: "bg-[#C4674F]/15 text-[#A0553F]",
};

export function UnitStatusBadge({ estado, className = "" }) {
  return (
    <span
      className={`inline-block rounded-sm px-2 py-1 text-xs font-medium ${STYLES[estado] || "bg-[#F1F3F3] text-[#3E5641]"} ${className}`}
      data-testid={`unit-status-${estado}`}
    >
      {estado}
    </span>
  );
}
